import { ref } from "vue";
import { Contest, ContestSubText, SbContest, UserStates } from "@/shared/model/contests";
import { TopTicketPeriod, TopTickets, TopTicketsData } from "@/shared/model/top-tickets";
import { useNgSession } from "@/shared/ng/ng-session";
import useUtils from "@/shared/composables/use-utils";

export const contests = ref<SbContest[]>([]);
export const topTickets = ref<TopTicketsData>(null);

const { session } = useNgSession();
const { formatDate } = useUtils();

export default function useSazkaContests() {
    const getContests = async (): Promise<void> => {
        let url = "https://sazka.imagelance.com/api/public/souteze/mobile-list";
        if (session.value?.PlayerID) {
            url += `/${session.value?.PlayerID}`;
        }

        try {
            const response = await fetch(url);

            if (!response.ok) {
                throw new Error(`Error fetching contests: ${response.statusText}`);
            }

            const data = await response.json();
            const contestData = data.map((contest: Contest) => {
                return {
                    ...transformedContest(contest),
                };
            });
            contests.value = contestData;
        } catch (error) {
            console.error(error);
            contests.value = [];
        }
    };

    const getTopTickets = async (period: TopTicketPeriod = TopTicketPeriod.WEEK): Promise<void> => {
        const url = `https://sazka.imagelance.com/api/public/ticket/best?period=${period}`;

        try {
            const response = await fetch(url);

            if (!response.ok) {
                throw new Error(`Error fetching top tickets: ${response.statusText}`);
            }

            const data: TopTickets = await response.json();
            topTickets.value = data.paginator?.data;
        } catch (error) {
            console.error(error);
            topTickets.value = null;
        }
    };

    const transformedContest = (contest: Contest): SbContest => {
        const contestAdditional = {
            icon: "",
            subText: "",
            type: "",
        };
        switch (contest.category) {
            case "marathon":
                contestAdditional.icon = "maraton";
                break;
            case "shooter":
                contestAdditional.icon = "strelec";
                break;
            case "tipcontest":
                contestAdditional.icon = "tipovacka-3";
                break;
            case "money_day":
                contestAdditional.icon = "money-day";
                break;
            case "calendar":
                contestAdditional.icon = "live-calendar";
                break;
            case "livebets_shooter":
                contestAdditional.icon = "live-calendar";
                break;
            case "lottery":
                contestAdditional.icon = "losovacka";
                break;
            default:
                contestAdditional.icon = "money-day";
        }

        const info = getContestInfo(contest);
        contestAdditional.subText = info.text;
        contestAdditional.type = info.type;

        return {
            ...contest,
            ...contestAdditional,
        };
    };

    const getContestInfo = (contest: Contest): ContestSubText => {
        const contestInfo: ContestSubText = {
            text: "Klikni a zapoj se do soutěže",
            type: "info",
        };
        if (contest.is_participant) {
            if (contest.user_state == UserStates.NOT_LOGIN || contest.user_state == null) {
                return contestInfo;
            } else {
                contestInfo.text = "Jsi ve hře, probíhá do " + formatDate(contest.end_at, "simple").dayDate;
                contestInfo.type = "success";

                if (contest.user_state == UserStates.NOT_BET_TODAY) {
                    if (contest.category == "marathon") {
                        contestInfo.text = "Nezapomeň si dnes vsadit";
                        contestInfo.type = "danger";
                    }
                    if (contest.category == "tipovacka") {
                        //TODO: Crosscheck category name
                        contestInfo.text = "Nezapomeň si dnes natipovat";
                        contestInfo.type = "danger";
                    }
                }

                if (contest.user_state == UserStates.FAILED) {
                    contestInfo.text = "Vypadl jsi ze hry";
                    contestInfo.type = "danger";
                }
            }
        }

        return contestInfo;
    };

    return {
        getContests,
        getTopTickets,
    };
}
